import { render, staticRenderFns } from "./DatasetPicker.vue?vue&type=template&id=520ae630&scoped=true&"
import script from "./DatasetPicker.vue?vue&type=script&lang=js&"
export * from "./DatasetPicker.vue?vue&type=script&lang=js&"
import style0 from "./DatasetPicker.vue?vue&type=style&index=0&id=520ae630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ae630",
  null
  
)

export default component.exports